<template>
    <div>
        <a-form-model :labelAlign="labelAlign" :rules="rules" :model="receiver" ref="receiverForm"
            class="underline_input_form">
            <div class="info_item_box">
                <div class="header_box">
                    <div>
                        <div class="flex_v_center">
                            <img src="~@/assets/images/function-service/ic_receive.png" width="26px" height="26px">
                            <span class="info_title">新增收货地址</span>
                        </div>
                        <div class="flex_v_center pointer" @click="showAddressModal">
                            <img src="~@/assets/images/function-service/ic_address.png" width="15px" height="18px" />
                            <span class="header_right_label">地址簿</span>
                        </div>
                    </div>
                </div>
                <div class="info_content" v-show="!isShowInputs">
                    <div class="input-group">
                        <a-row type="flex">
                            <a-col flex="1">
                                <a-form-model-item label="收货人" prop="name">
                                    <a-input v-model="receiver.name" @change="resetReceiveId" placeholder="请输入收货人姓名" />
                                </a-form-model-item>
                            </a-col>
                            <a-col flex="1" :offset="2">
                                <a-form-model-item label="手机号码" prop="mobile">
                                    <a-input v-model="receiver.mobile" @change="resetReceiveId"
                                        placeholder="请输入收货人手机号码" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row type="flex">
                            <a-col flex="1">
                                <a-form-model-item label="所在地区" prop="region">
                                    <select-address :region="receiver.region" @change="changeRegion" ref="region" drop
                                        style="width: 100%" :key="regionKey" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row type="flex">
                            <a-col flex="1" :offset="2" class="address-input">
                                <a-form-model-item label="详细地址" prop="address">
                                    <a-textarea v-model="receiver.address" @change="resetReceiveId"
                                        placeholder="请输入真实地址，不需要重复填写省市区" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </div>

                    <!-- <a-row v-if="hasTel">
                        <a-col :span="11">
                            <a-form-model-item label="固定电话" prop="tel">
                                <a-input-number v-model="receiver.tel" @change="resetReceiveId" placeholder="请输入固定电话" />
                            </a-form-model-item>
                        </a-col>
                    </a-row> -->
                    <div class="text-area">
                        <a-row>
                            <a-col :span="11" style="width: 100%">
                                <smart-address-textarea @ok="recognizeAddress" />
                            </a-col>
                        </a-row>
                    </div>
                </div>

                <div class="btns" v-show="!isShowInputs">
                    <a-button type="primary" @click="doConfirm">确认并使用</a-button>
                    <a-button @click="doClear">清空</a-button>
                </div>
                <a-row type="flex" v-show="isShowInputs">
                    <a-col flex="1">
                        <a-form-model-item label="收货人" prop="name" style="padding: 10px 0 0;">
                            {{ receiver.name }}，{{ `${Area}${receiver.address}` }} ,
                            {{ receiver.mobile }}
                            <span class="changeSender" @click="ChangeRecevier">更改</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
        </a-form-model>
        <address-modal v-model="isShowAddressModal" @change="changeReceiveAddress" @change2="getArea_info" />
    </div>
</template>

<script>
import SelectAddress from '@/components/common/address/CascaderAddress.vue'
import SmartAddressTextarea from '@/components/common/address/SmartAddressTextarea.vue'
import AddressModal from '@/components/common/express/AddressModal.vue'

export default {
    name: 'ReceiverForm',
    components: {
        AddressModal,
        SmartAddressTextarea,
        SelectAddress
    },
    model: {
        prop: 'receiver',
        event: 'change'
    },
    props: {
        receiver: {
            type: Object,
            required: true
        },
        labelAlign: {
            type: String,
            required: false,
            default: 'left'
        },
        hasTel: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        receiver: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.area_info) {
                    this.isShowInputs = true;
                    this.Area = newVal.area_info;
                    console.log(this.isShowInputs);
                }
            }
        }
    },
    data() {
        return {
            isShowAddressModal: false,
            rules: {
                name: [
                    { required: true, message: '请输入收货人姓名', trigger: ['blur', 'change'] }
                ],
                mobile: [
                    { required: true, message: '请输入收货人手机号码', trigger: ['blur', 'change'] },
                    // { validator: this.$validate.mobile, trigger: ['blur', 'change'] }
                ],
                address: [
                    { required: true, message: '请输入收货的详细地址', trigger: ['blur', 'change'] },
                ],
                region: [
                    { required: true, message: '请选择所在地区', trigger: ['blur', 'change'] },
                ],
                tel: [
                    { validator: this.$validate.tel, trigger: ['blur', 'change'] }
                ]
            },
            isShowInputs: false,
            Area: '',
            regionKey: 1
        }
    },
    created() {
        this.$EventBus.$on('inpusShow', this.doConfirm)
        this.$EventBus.$on('Area_info', area => this.Area = area)
    },
    methods: {
        showAddressModal() {
            this.isShowAddressModal = true
        },
        resetReceiveId() {
            if (this.receiver.id) this.receiver.id = ''
        },
        resetReceiverValidate() {
            this.$refs.receiverForm.clearValidate()
            this.receiver.region = {
                province_id: '',
                city_id: '',
                district_id: '',
                town_id: ''
            }
        },
        changeReceiveAddress(data) {
            this.$emit('change', data)
        },
        getArea_info(area) {
            this.Area = area
        },
        recognizeAddress(data) {
            this.resetReceiverValidate()

            const receiver = {
                id: '',
                name: data.name,
                mobile: data.mobile,
                region: {
                    province_id: data.province.id,
                    city_id: data.city.id,
                    district_id: data.district.id,
                    town_id: data.town.id
                },
                address: data.address
            }
            this.$emit('change', receiver)

        },
        changeRegion(val) {
            // this.receiver.region.province_id = val.province_id;
            // this.receiver.region.city_id = val.city_id;
            // this.receiver.region.district_id = val.district_id;
            // this.receiver.region.town_id = val.town_id;

            Object.assign(this.receiver.region, val)
            this.Area = val.provinceName + val.cityName + val.districtName + val.townName

            // console.log('receiver', this.receiver);
            this.$emit('change', this.receiver);
        },
        validate() {
            return new Promise((resolve, reject) => {
                let _validate = true
                this.$refs.receiverForm.validate(valid => {
                    if (!valid) _validate = false
                })
                this.$refs.region.validate(valid => {
                    if (!valid) _validate = false
                })

                if (_validate) {
                    resolve()
                } else {
                    reject(new Error('receiverForm has error'))
                }
            })
        },
        changeSelectAddress(data) {
            if (data.province_id != undefined && data.province_id > 0) {
                this.receiver.region.province_id = data.province_id
            }
            if (data.city_id != undefined && data.city_id > 0) {
                this.receiver.region.city_id = data.city_id
            }
            if (data.district_id != undefined && data.district_id > 0) {
                this.receiver.region.district_id = data.district_id
            }
            if (data.town_id != undefined && data.town_id > 0) {
                this.receiver.region.town_id = data.town_id
            }
        },
        ChangeRecevier() {
            this.isShowInputs = false
        },
        doConfirm() {
            this.$refs.receiverForm.validate((valid) => {
                const { province_id, city_id, district_id } = this.receiver.region
                // console.log(this.receiver.region);
                if (valid === true && province_id && city_id) {
                    this.isShowInputs = true
                } else {
                    this.$message.error('请完善收货信息')
                }
            })
        },
        doClear() {
            this.$emit('ClearRegion')
            this.$refs.receiverForm.clearValidate()
            this.regionKey++
        }
    }
}
</script>

<style scoped>
.info_item_box {
    overflow: hidden;
}

.info_item_box>.btns {
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btns>button {
    width: 99px;
    height: 32px;
}

.btns>button+button {
    transform: translateX(-60px);
}

.btns>.ant-btn-primary {
    margin-right: 80px;
}

.info_item_box .header_box {
    background: #fff;
    height: 44px;
    line-height: 44px;
}

.header_box>div {
    background: #fafafa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 10px;
    height: 44px;
}

.info_item_box .info_title {
    font-size: 16px;
    margin-left: 10px;
    font-weight: 400;
    font-family: "Alibaba PuHuiTi";
}

.header_right_label {
    margin-left: 5px;
    font-size: 15px;
    cursor: pointer;
}

.info_content {
    padding: 25px 10px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
}

.info_item_box>>>.ant-form-item {
    width: 100%;
}

.input-group {
    /* border-right: 1px solid #D8D8D8; */
    padding: 0 60px 0 20px;
    box-sizing: border-box;
    width: 48%;
}


.ant-row-flex {
    flex-wrap: wrap;
}

.ant-input {
    border-radius: 4px;
    border: 1px solid #D8D8D8 !important;
    background: #FFF;
    width: 100%
}

.ant-col-offset-2 {
    margin-left: 2.33%;
}

.ant-space-item {
    width: 100%;
}

>>>.address_box {
    width: 100%;
}

>>>.ant-space-item {
    width: 100%;
    margin-right: unset !important;
}

.address-input {
    margin-left: 0;
}

.address-input textarea {
    resize: none;
    height: 76px
}

.text-area {
    width: 48%;
    padding: 0 12px 0 3px;
    box-sizing: border-box;
}

@media screen and (max-width: 1400px) {
    .text-area {
        padding: 0 12px 0 0;
    }

    .input-group {
        width: 49%;
    }

    .info_item_box>.btns {
        margin-left: 1%;
    }
}

.changeSender {
    color: #fd5902;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 10px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/express/ReceiverForm.vue